module.exports = __webpack_public_path__ + "static/media/safe2logo.50a87805.png";